import "./AnovaTable.css";

import { Alert, Badge, Button, Table } from "reactstrap";

import { ComponentPlaceholder } from "../../../../../components/componentPlaceholder/componentPlaceholder";
import { ComponentTitle } from "../../../../../components/componentTitle/componentTitle";
import { LinearModel } from "../LinearModel/LinearModel";
import PropTypes from "prop-types";
import { PropertyRow } from "../PropertyRow";
import { format } from "date-fns";
import { truncateNumber } from "../../../../../services/utils";

export const AnovaTable = ({ computedAnova, displayedTukey, displayTukey }) => {
  const rows = computedAnova?.anova
    ? Object.entries(computedAnova.anova).sort(
        ([, a], [, b]) =>
          Number.parseFloat(a["PR(>F)"]) - Number.parseFloat(b["PR(>F)"])
      )
    : [];

  return (
    <div className="powerdash-component gap-1">
      <ComponentTitle
        icon="fa-solid fa-flask-vial"
        title="ANOVA"
        topRightContent={
          computedAnova && (
            <div className="d-flex gap-3 align-items-center">
              <Badge className="hiphen-badge">
                <i className="fa-solid fa-flask me-1" />
                {computedAnova.experiment}
              </Badge>
              <span>
                <i className="fa-solid fa-calendar-days" /> {computedAnova.date}
              </span>
              <span className="font-style-italic">
                <i className="fa-solid fa-table-cells discrete-icon" />{" "}
                {computedAnova.length} plots
              </span>
              <span className="font-style-italic">
                <i className="fa-regular fa-clock discrete-icon" /> Calculated{" "}
                {format(new Date(computedAnova.datetime), "yyyy-MM-dd HH:mm")}
              </span>
            </div>
          )
        }
      />
      {computedAnova ? (
        <>
          <LinearModel model={computedAnova.linear_model} />
          <div className="anova-table">
            {computedAnova.anova_error ? (
              <Alert color="danger" className="d-flex flex-column gap-1">
                <span>Something went wrong during ANOVA calculation</span>
                <code className="p-2">{computedAnova.anova_error}</code>
              </Alert>
            ) : (
              <Table className="mt-2">
                <thead>
                  <tr>
                    <th>Attribute</th>
                    <th>sum_sq</th>
                    <th>df</th>
                    <th>F</th>
                    <th>p-value</th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map(([key, value]) => (
                    <tr key={key.replaceAll(":", "")}>
                      <td className="property">
                        <PropertyRow name={key} />
                      </td>
                      <td>{truncateNumber(value.sum_sq)}</td>
                      <td>{truncateNumber(value.df)}</td>
                      <td>{truncateNumber(value.F)}</td>
                      <td>
                        {Number.parseFloat(value["PR(>F)"]).toExponential(2)}
                      </td>
                      <td className="text-center">
                        {key !== "Residual" && (
                          <>
                            {value["PR(>F)"] < 0.05 && (
                              <i className="fa-solid fa-star" />
                            )}
                            {value["PR(>F)"] < 0.01 && (
                              <i className="fa-solid fa-star" />
                            )}
                            {value["PR(>F)"] < 0.001 && (
                              <i className="fa-solid fa-star" />
                            )}
                          </>
                        )}
                      </td>
                      <td className="text-end">
                        {key !== "Residual" && (
                          <Button
                            color="success"
                            size="sm"
                            onClick={() => displayTukey(key)}
                            disabled={displayedTukey === key}
                          >
                            Tukey HSD
                            <i className="ms-1 fa-solid fa-magnifying-glass" />
                          </Button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </div>
        </>
      ) : (
        <ComponentPlaceholder icon="fa-solid fa-table" />
      )}
    </div>
  );
};

AnovaTable.propTypes = {
  computedAnova: PropTypes.shape({
    anova: PropTypes.object,
    linear_model: PropTypes.string,
    anova_error: PropTypes.string,
    experiment: PropTypes.string,
    date: PropTypes.string,
    length: PropTypes.number,
    datetime: PropTypes.string,
    tukey: PropTypes.object,
    tukey_errors: PropTypes.object,
  }),
  displayedTukey: PropTypes.string,
  displayTukey: PropTypes.func,
};
